import React,{useState, useEffect} from 'react'
import Alphabet from './Alphabet'

const SearchByLetter = ({items, label, inputType, buttonLabel, onFetchData, clearAlpActive}) => {

    const [letter, setLetter] = useState() 
    const [activeId, setActiveId] = useState(' ')

    useEffect(() => {
        !clearAlpActive && setActiveId('')
    },[clearAlpActive])

    const eventHandler = (id, data) => {
        setLetter(data.letter)
        setActiveId(id)
        onFetchData(data.letter, 'searchbyalphabet','null', data.letter)
    } 

    return(
        <React.Fragment>
            <div className="blk blk-alplinks">
                <label>{label}</label>
                <div className="alplinks">
                    {
                        items.map(
                            item => {
                                return <Alphabet 
                                    items={item} 
                                    key={item.id} 
                                    fields={item.fields} 
                                    onChange={eventHandler.bind(this, item.id)}
                                    clsName = { activeId === item.id ? 'active' : null }
                                    name={letter}
                                />
                            }
                        )
                    }
                </div>
            </div>
            
        </React.Fragment>
    )
}

export default SearchByLetter;